let data18;
if (typeof window === "undefined") {
  data18 = require("../static-s18/Data.json");
} else {
  data18 = require("../static-s18/Data.json");
  window.data18 = data18;
  // data18 = window.data18;
}

export { data18 };
